const STORAGE_KEY = 'app.wishlists.pending_booking';

export interface PendingBooking {
  /** Item the guest wanted to book before being asked to sign in. */
  itemUuid: string;
  /** Page to return to once the sign-in flow is finished. */
  returnTo: string;
}

export const setPendingBooking = (booking: PendingBooking) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(booking));
};

export const peekPendingBooking = (): PendingBooking | null => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return parsed?.itemUuid ? parsed as PendingBooking : null;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const clearPendingBooking = () => localStorage.removeItem(STORAGE_KEY);
